import AuthService from "@/services/AuthenticationService";
import { global } from "./global.module";
let user = {};
if (
  process.env.VUE_APP_SOURCE_NAME == "shopifyimporter" &&
  window.self !== window.top
) {
  // need to access the store global state to get the user
  user = global.state.global_user;
} else {
  user = JSON.parse(localStorage.getItem("user"));
}

const initialState = user
  ? { status: { loggedIn: true }, user }
  : { status: { loggedIn: false }, user: null };

export const auth = {
  namespaced: true,
  state: initialState,
  actions: {
    login({ commit }, user) {
      return AuthService.login(user).then(
        (user) => {
          commit("loginSuccess", user);
          return Promise.resolve(user);
        },
        (error) => {
          commit("loginFailure");
          return Promise.reject(error);
        }
      );
    },
    refreshToken({ commit }, accessToken) {
      commit("refreshToken", accessToken);
    },
    logout({ commit }) {
      AuthService.logout();
      commit("logout");
    },
    register({ commit }, user) {
      return AuthService.register(user).then(
        (response) => {
          commit("registerSuccess");
          return Promise.resolve(response.data);
        },
        (error) => {
          commit("registerFailure");
          return Promise.reject(error);
        }
      );
    },
    requestForgotPassword({ commit }, payload) {
      return AuthService.requestForgotPassword(payload).then(
        (response) => {
          return Promise.resolve(response.data);
        },
        (error) => {
          commit("requestForgotPasswordFailure");
          return Promise.reject(error);
        }
      );
    },
    resetPassword({ commit }, payload) {
      return AuthService.resetPassword(payload).then(
        (response) => {
          commit("resetPasswordSuccess");
          return Promise.resolve(response.data);
        },
        (error) => {
          commit("resetPasswordFailure");
          return Promise.reject(error);
        }
      );
    },
  },
  mutations: {
    loginSuccess(state, user) {
      state.status.loggedIn = true;
      state.user = user;
    },
    loginFailure(state) {
      state.status.loggedIn = false;
      state.user = null;
    },
    refreshToken(state, accessToken) {
      state.status.loggedIn = true;
      state.user = { ...state.user, accessToken: accessToken };
    },
    logout(state) {
      state.status.loggedIn = false;
      state.user = null;
    },
    registerSuccess(state) {
      state.status.loggedIn = false;
    },
    registerFailure(state) {
      state.status.loggedIn = false;
    },
    requestForgotPasswordSuccess(state) {},
    requestForgotPasswordFailure(state) {},
    resetPasswordSuccess(state) {},
    resetPasswordFailure(state) {},
  },
};
